export default {
	menu: {
		home: "Home",
		install: "Install a Room",
		project: "Project Manager",
		live: "Live View",
		dashboard: "Dashboard",
		k4noc: "K4NOC",
		about: "About",
		lock: "Lock Manager",
		logout: "Logout",
	},
	login: {
		defaultError:
			"There was an issue logging in. Please check your username and password and try again.",
		forbiddenError:
			"You don't have the required user roles to access this application.",
	},
	home: {
		empty: {
			desktop:
				"Your account is not configured for any K4Ops desktop features. Please check with support or try the K4Ops mobile application.",
			mobile:
				"Your account is not configured for any K4Ops mobile features. Please check with support or try https://ops.k4connect.com",
		},
	},
	live: {
		titles: {
			community: "Live - Community View",
			system: "Live - System View",
			user: "Live - User View",
			default: "Live",
		},
		scenes: {
			addScene: "Add scene",
			wizards: {
				title: "Scene Wizards",
				add: {
					manual: "Manual Scene",
					temperature: "Temperature Change",
					trigger: "Triggered Scene",
				},
			},
			removeSceneConfirmation:
				"Are you sure you want to permanently remove this scene?",
			renameSceneDialog: {
				title: "Rename a scene",
				body: "Give an existing scene a new name.",
				error: "Failed to rename scene",
				deleteError: "Failed to delete scene",

				nameLabel: "Name",
				cancel: "Cancel",
				submit: "Rename",
			},
			addSceneDialog: {
				title: "Create a new scene",
				body:
					"Create a new set of automated actions and the conditions that trigger them.",
				error: "Failed to create the new scene",

				nameLabel: "Name",
				cancel: "Cancel",
				submit: "Create",
			},
			dateConditionDialog: {
				new: {
					title: "Add new date condition",
					error: "Failed to create condition",
					cancel: "Cancel",
					submit: "Create",
				},
				update: {
					title: "Edit date condition",
					error: "Failed to update condition",
					cancel: "Cancel",
					submit: "Update",
				},
			},
			timeConditionDialog: {
				new: {
					title: "Add new time condition",
					error: "Failed to create condition",
					cancel: "Cancel",
					submit: "Create",
				},
				update: {
					title: "Edit time condition",
					error: "Failed to update condition",
					cancel: "Cancel",
					submit: "Update",
				},
			},
			varConditionDialog: {
				new: {
					title: "Add condition",
					body:
						"Add a new condition to the scene that checks the value of a device variable.",
					error: "Failed to create condition",
					cancel: "Cancel",
					submit: "Create",
				},
				update: {
					title: "Update condition",
					error: "Failed to update condition",
					cancel: "Cancel",
					submit: "Update",
				},
			},
			eventConditionDialog: {
				new: {
					title: "Add event condition",
					body:
						"Add a new event condition to the scene. The event must fire for the scene to trigger.",
					error: "Failed to create event condition",
					cancel: "Cancel",
					submit: "Create",
				},
				update: {
					title: "Update event condition",
					error: "Failed to update event condition",
					cancel: "Cancel",
					submit: "Update",
				},
			},
			intervalDialog: {
				new: {
					title: "Add interval",
					body:
						"Fires every X seconds, making a scene that executes at a set interval.",
					error: "Failed to create interval",
					cancel: "Cancel",
					submit: "Create",
				},
				update: {
					title: "Update interval",
					body:
						"Fires every X seconds, making a scene that executes at a set interval.",
					error: "Failed to update interval",
					cancel: "Cancel",
					submit: "Update",
				},
			},
			commandStepDialog: {
				new: {
					title: "Execute a command",
					body:
						"Steps can be an event to fire, a command to execute, or a delay in between other steps. All steps are run from top to bottom, in order, when a scene is triggered.",
					error: "Failed to add command",
					cancel: "Cancel",
					submit: "Create",
				},
				update: {
					title: "Execute a command",
					error: "Failed to update command",
					cancel: "Cancel",
					submit: "Update",
				},
			},
			eventStepDialog: {
				new: {
					title: "Fire an event",
					body:
						"Steps can be an event to fire, a command to execute, or a delay in between other steps. All steps are run from top to bottom, in order, when a scene is triggered.",
					error: "Failed to add event",
					cancel: "Cancel",
					submit: "Create",
				},
				update: {
					title: "Update event step",
					error: "Failed to update event",
					cancel: "Cancel",
					submit: "Update",
				},
			},
			delayStepDialog: {
				new: {
					title: "Add a delay",
					body:
						"Add a configurable delay between the execution of other steps.",
					error: "Failed to add delay",
					cancel: "Cancel",
					submit: "Create",
				},
				update: {
					title: "Update delay",
					body:
						"Add a configurable delay between the execution of other steps.",
					error: "Failed to update delay",
					cancel: "Cancel",
					submit: "Update",
				},
			},
			temperatureWizardDialog: {
				title: "Temperature Change Wizard",
				error: "Failed to save wizard",
				cancel: "Cancel",
				submit: "Save",
			},
			triggerWizardDialog: {
				title: "Trigger Scene Wizard",
				error: "Failed to save wizard",
				cancel: "Cancel",
				submit: "Save",
			},
		},
	},
	dashboard: {
		title: "Installation Report",
		community: {
			select: "Select a community to view",
			current: "Currently viewing",
		},
	},
	k4noc: {
		titles: {
			default: "Tickets",
			moves: "Room Moves",
			device: "Device Status",
		},
		moves: {
			title: "Room Move",
			subtext: {
				room: {
					"New Resident": ([_, to]) => `Assigning resident to "${to}".`,
					Move: ([current, to]) =>
						`Moving resident from "${current}" to "${to}".`,
					"Move Out": ([current]) =>
						`Existing assignment "${current}" will be removed.`,
				},
				scene: room => `Currently editing scenes for "${room}".`,
				sceneError: room => `Couldn't connect to "${room}".`,
			},
			dialog: {
				assoc: {
					create: {
						title: "Add Personal Device",
						cancel: "Cancel",
						submit: "Create",
						nameLabel: "Name",
						typeLabel: "Type",
						idLabel: "Identifier",
					},
					update: {
						title: "Edit Personal Device",
						cancel: "Cancel",
						submit: "Update",
						nameLabel: "Name",
						typeLabel: "Type",
						idLabel: "Identifier",
					},
				},
				devices: {
					remove: "Are you sure you want to remove this personal device?",
				},
				markComplete:
					'"I have made all the necessary changes for this ticket."',
			},
		},
		alarms: {
			pending: "Pending Alarms",
			older: "Older Alarms",
			pendingDesc:
				"These alarms are less than 1 hour old and will likely resolve themselves. We’ll continue to monitor them, but they can be ignored for now",
			olderDesc:
				"These are previously reported alarms that are older than 30 days, but were not resolved. If the device is missing or removed, they should be marked as Disabled or Snoozed until the device is replaced.",
			show: "Show",
			shown: "shown",
			hide: "Hide",
			tips: {
				title: "Some helpful tips…",
				bullet1:
					"It’s not unusual to see occasional short periods offline throughout the day due to internet interruptions, software updates, or the controller restarting itself automatically.",
				bullet2:
					"Occasional dips below the expected threshold of WiFi signal is normal due to interference or noise.",
				bullet3:
					"These short Pending alarms are normal and expected behavior. They usually resolve themselves after a few minutes and should only be of concern if happening many times per day, across multiple days.",
			},
			wizard: {
				missing: "No wizards were found to fix this alarm.",
				success: "Success!",
				postSuccess:
					"The alarm should close automatically in the next few minutes.",
				postFail: "Please try the next step.",
				notes: "Notes",
				goBack: "Go back",
				nextStep: "Next step",
				confirm: "Done",
				close: "Cancel",
				gotIt: "Got it!",
				zwaveTest: "Please check if the Zwave stick is properly connected.",
				fails: {
					controllerConnection: "Couldn't connect to the controller.",
					cpuTemperature: temp =>
						`The CPU temperature is still higher than normal. The reported temperature was ${temp}°C, while the normal rate is less than 65°C.`,
					noWifi: "This device has no wifi adaptor.",
					weakWifi:
						"The Wifi connection is still weaker than normal. Please try the next step.",
					batteryLevel: level =>
						`The device battery isn't new. The reported battery level was ${level}`,
					deadDevice: "The device still isn't responding.",
					generic: "We encountered a problem while executing the test.",
					zwave: "Couldn't connect to the Zwave/Zipgateway.",
				},
			},
			dialog: {
				enable: {
					title: "Enable this alarm?",
					body: (type, path) =>
						`Confirming will re-enable alarms for ${type} to the ${path}`,
					confirm: "Enable",
				},
			},
		},
	},
	lock: {
		add: {
			lock: "Register Lock",
			users: "Manage Users",
		},
	},
	install: {
		title: "Install a Room",
		exit:
			"All of your changes have been saved, but your progress may be lost if you stop the installation now.",
		qrError: "Couldn't find system using QR code",
	},
	project: {
		titles: {
			accessGroups: "Access Groups",
			default: "Project Manager",
		},
		accessGroups: {
			select: "Select an access group to view associations",
			addAccessGroup: "Add access group",
			createUser: "Create user",
		},
		dialogs: {
			addAccessGroup: {
				title: "Create an access group",
				body:
					"Create a new access group that you can add communities and operators to.",
				error: "Failed to create access group",

				nameLabel: "Group name",
				cancel: "Cancel",
				submit: "Submit",
			},
			createUser: {
				title: "Create user",
				body:
					"Create a new advocate or external user to associate with an existing association group.",
				error: "Failed to create user",

				roles: {
					advocate: "K4 Advocate",
					thirdParty: "Third-party Installer",
				},
				accessGroup: "Access group",
				firstName: "First name",
				lastName: "Last name",
				email: "Email",
				password: "Password",
				cancel: "Cancel",
				submit: "Submit",
			},
			renameAccessGroup: {
				title: "Rename access group",
				error: "Failed to rename access group",

				nameLabel: "Name",
				cancel: "Cancel",
				submit: "Rename",
			},
			addCommunities: {
				title: "Add communities",
				body:
					"Add one or more existing communities to the access group. Users in the group will gain access to the selected communities.",
				error: "Failed to add selected communities",

				nameLabel: "Communities",
				cancel: "Cancel",
				submit: "Add",
			},
			addUsers: {
				title: "Add users",
				body:
					"Add one or more existing users to the access group. The added users will gain access to the communities in the group.",
				error: "Failed to add selected users",

				nameLabel: "Users",
				cancel: "Cancel",
				submit: "Add",
			},
		},
	},
	community: {
		title: "Community",
		header: "Alright, let's select a community...",
		search: "Search for a Community",
	},
	room: {
		title: "Room",
		header: "Now let's select a system to install...",
		confirm:
			"This system has already been installed. If you continue, you could overwrite changes that have been made remotely.",
		search: "Search for a Room",
	},
	devices: {
		title: "Device Pairing",
		header:
			"Now let's pair your devices. You can also add and remove devices before continuing.",
		hideInstalled: "Hide installed devices",
		addDevice: "Add Device",
		addRoom: "Add Room",
		complete: "You're ready to save your changes to the controller!",
		completeSkipToTest: "You're ready to start testing!",
		altComplete: "All devices must be paired before you can proceed",
		confirm:
			"This device has already been paired. You may need to unpair the device before pairing again.",
		removeRoomNotEmpty: "Room must be empty before it can be removed",
	},
	provision: {
		title: "Save Changes",
		header:
			"Let's save your changes to the controller and get everything up and running.",
		complete: "Finished saving your changes!",
		connectError:
			"Unable to connect to the controller. Please check that it is online, you are on the same wifi, and try again.",
		stepOne: "Finding controller...",
		stepTwo: "Saving settings to controller...",
		stepThree: "Reconnecting to controller...",
	},
	testing: {
		title:
			"Now let's test your devices to make sure that everything is working. Press the play button on each device to run tests.",
	},
	report: {
		title: "Installation Report",
		header: "You're all done! We're just going to file some quick paperwork...",
		submitting: "Submitting report...",
		success: "All done!",
		failure:
			"Failed to submit report. Please check your internet connection and try again.",
		new: "Install Another Room",
		home: "Home",
	},
	dialogs: {
		default: {
			title: "Are you sure?",
			body: "This will make changes you cannot undo.",
		},
		move: {
			title: "Move device",
			body: "Move the device to another room.",
			error: "Failed to move device",
		},
		rename: {
			title: "Rename Device",
			error: "Failed to rename device",
		},
		removeDevice: {
			body: "This will permanently delete this device.",
		},
		removeRoom: {
			body: "This will permanently delete this room.",
		},
		addRoom: {
			title: "Add a new room",
			error: "Failed to add room",
		},
		addDevice: {
			title: "Add new device",
			error: "Failed to add device",
		},
	},
};
